<template>
  <component
    :is="tag"
    :type="nativeType"
    class="app-button-control"
    :class="rootClass"
    @click="handlerClick"
    v-bind="$attrs"
    :disabled="isDisabled || loading"
    ref="rippleBtn"
    :style="{ 'padding-left': `${padding}px`, 'padding-right': `${padding}px` }"
  >
    <transition-group v-if="type !== 'link'">
      <span
        class="ripple-reaction"
        :key="ripple.id"
        v-for="ripple in ripples"
        :style="{ top: ripple.y + 'px', left: ripple.x + 'px' }"
        @animationend="rippleEnd(ripple.id)"
      >
      </span>
    </transition-group>
    <span v-if="loading" class="app-button-control__loading">
      <loader class="app-button-control__loader" :is-white="isWhiteLoader" />
    </span>
    <template v-else>
      <span
        v-if="type === 'vk'"
        class="app-button-control__content"
        :class="customContentClass"
      >
        <svg-icon class="app-button-control__icon" name="vk_white_20" />
        <slot>Вконтакте</slot>
      </span>
      <span
        v-else-if="type === 'facebook'"
        class="app-button-control__content"
        :class="customContentClass"
      >
        <svg-icon class="app-button-control__icon" name="fb_white_20" />
        <slot>FACEBOOK</slot>
      </span>
      <span
        v-else-if="type === 'apple'"
        class="app-button-control__content"
        :class="customContentClass"
      >
        <svg-icon class="app-button-control__icon" name="apple_white_20" />
        <slot>Вход с Apple</slot>
      </span>
      <span
        v-else-if="type === 'google'"
        class="app-button-control__content"
        :class="customContentClass"
      >
        <svg-icon class="app-button-control__icon" name="google" />
        <slot>GMAIL</slot>
      </span>
      <span
        v-else-if="type === 'sberbusiness'"
        class="app-button-control__content"
        :class="customContentClass"
      >
        <svg-icon class="app-button-control__icon" name="sberbank_white_22" />
        <slot>Войти по СберБизнес ID</slot>
      </span>
      <span
        v-else-if="type === 'alfabank'"
        class="app-button-control__content"
        :class="customContentClass"
      >
        <img src="/static/images/alfa-white.svg" alt="" />
        <span> <slot></slot></span>
      </span>
      <span
        v-else-if="type === 'gosuslugi'"
        class="app-button-control__content"
        :class="customContentClass"
      >
        <svg-icon class="app-button-control__icon" name="gos" />
        <slot>Войти через Госуслуги</slot>
      </span>
      <span
        v-else-if="type === 'sberbusiness-white'"
        class="app-button-control__content"
        :class="customContentClass"
      >
        <svg-icon class="app-button-control__icon" name="sberbank_22" />
        <slot>Войти по СберБизнес ID</slot>
      </span>
      <span
        v-else-if="type === 'reset'"
        class="app-button-control__content"
        :class="customContentClass"
      >
        <svg-icon class="app-button-control__icon" name="close" />
        <slot>Сбросить</slot>
      </span>
      <span
        v-else
        class="app-button-control__content"
        :class="customContentClass"
      >
        <slot>Отправить</slot>
      </span>
    </template>
  </component>
</template>

<script>
export default {
  name: 'ButtonControl',
  components: {
    SvgIcon: () => import('@/components/common/AppSvgIcon'),
    loader: () => import('@/components/ui/AppLoader'),
  },
  props: {
    tag: {
      type: String,
      default: 'button',
    },
    nativeType: {
      type: String,
      default: 'button',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isWhiteLoader: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'default', // 'secondary' || 'link'
    },
    isBlock: {
      type: Boolean,
      default: false,
    },
    isAddedDisabledClassName: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'normal',
    },
    route: {
      type: String,
      default: '',
    },
    isUppercase: {
      type: Boolean,
      default: false,
    },
    isCapitalize: {
      type: Boolean,
      default: false,
    },
    isDefaultTransform: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: String,
      default: 'default',
    },
    customContentClass: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    ripples: [],
  }),
  computed: {
    /**
     * Отступ для кнопоки
     */
    innerPadding() {
      if (this.padding === 'default') {
        if (this.isBlock) {
          return '0';
        }
        if (this.size === 'large') {
          return '38';
        }
        if (this.size === 'small') {
          return '20';
        }
        return '30';
      }
      return this.padding;
    },
    /**
     * Основой класс кнопки
     */
    rootClass() {
      return [
        {
          'app-button-control--purple': this.type === 'purple',
          'app-button-control--secondary': this.type === 'secondary',
          'app-button-control--green': this.type === 'green',
          'app-button-control--secondary--capitalize':
            this.type === 'secondary' && this.isCapitalize,
          'app-button-control--secondary--default-transform':
            this.type === 'secondary' && this.isDefaultTransform,
          'app-button-control--link': this.type === 'link',
          'app-button-control--vk': this.type === 'vk',
          'app-button-control--fb': this.type === 'facebook',
          'app-button-control--apple': this.type === 'apple',
          'app-button-control--google': this.type === 'google',
          'app-button-control--sberbank': this.type === 'sberbusiness',
          'app-button-control--alfabank': this.type === 'alfabank',
          'app-button-control--sberbank-white':
            this.type === 'sberbusiness-white',
          'app-button-control--gosuslugi': this.type === 'gosuslugi',
          'app-button-control--green-border': this.type === 'green-border',
          'app-button-control--white': this.type === 'white',
          'app-button-control--reset': this.type === 'reset',
          'app-button-control--gray': this.type === 'gray',
          'app-button-control--border-grey': this.type === 'border-grey',
          'app-button-control--border-grey-light':
            this.type === 'border-grey-light',
          'app-button-control--red': this.type === 'red',
          'app-button-control--large': this.size === 'large',
          'app-button-control--small': this.size === 'small',
          'app-button-control--loading': this.loading,
          'app-button-control--block': this.isBlock,
          'app-button-control--disabled': this.isAddedDisabledClassName,
          'app-button-control--uppercase': this.isUppercase,
        },
      ];
    },
  },
  methods: {
    /**
     * Событие клика на кнопку
     * @param event
     */
    handlerClick(event) {
      if (this.route) {
        this.$router.push(this.route);
      }
      this.$emit('click', event);

      // Ripple animation
      const el = this.$refs.rippleBtn;
      const pos = el.getBoundingClientRect();
      const rippleId = Date.now();

      this.ripples.push({
        x: event.clientX - pos.left,
        y: event.clientY - pos.top,
        id: rippleId,
      });
    },
    /**
     * Эффект на кнопке
     * @param i
     */
    rippleEnd(i) {
      const index = this.ripples.indexOf(i);
      this.ripples.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
.ripple-reaction {
  position: absolute;
  z-index: 4;
  width: 30rem;
  height: 30rem;
  margin-top: -15rem;
  margin-left: -15rem;
  pointer-events: none;
  background-color: $color-ripple-2;
  border-radius: 50%;
  outline: none;
  opacity: 0;
  animation: ripple-animation 0.75s;
}

@keyframes ripple-animation {
  from {
    opacity: 1;
    transform: scale(0);
  }

  to {
    opacity: 0;
    transform: scale(1, 1);
  }
}

.app-button-control {
  $this: &;

  @include a-reset;
  @include button-reset;

  position: relative;
  display: inline-flex;
  justify-content: center;
  height: 40px;
  padding: 0 30px;
  overflow: hidden;
  font-size: rem(13);
  font-weight: 300;
  line-height: 1.2;
  text-align: left;
  letter-spacing: 0.04em;
  user-select: none;
  background-color: $color-white;
  border: 1px solid $color-gray-2;
  border-radius: 4px;
  transition: border-color $A, background-color $A, color $A;
  transform: translateZ(0);

  &:hover {
    color: $color-brand-green;
    background-color: $color-gray-0;
  }

  &:disabled {
    color: $color-gray-8;
    border-color: $color-gray-5 !important;

    .svg-icon {
      fill: $color-gray-8;
    }
  }

  &__loading {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__content {
    display: flex;
    align-items: center;
    margin: auto;
    text-align: center;
  }

  &__icon {
    @include size(16px);

    margin-right: 6px;
    transition: fill $A;
  }

  // size large
  &--large {
    height: 50px;
    padding: 0 38px;
  }

  // size small
  &--small {
    height: 32px;
    padding: 0 20px;
    font-size: rem(12);

    .ripple-reaction {
      width: 15rem;
      height: 15rem;
      margin-top: -7.5rem;
      margin-left: -7.5rem;
    }
  }

  // block
  &--block {
    display: flex;
    width: 100%;
    padding-right: 0;
    padding-left: 0;
  }
  // type reset
  &--reset {
    color: $color-gray-8;
    #{$this}__icon {
      @include size(9px);

      margin-right: 9px;
      fill: $color-gray-8;
    }

    &:hover {
      color: $color-black;
      #{$this}__icon {
        fill: $color-black;
      }
    }

    &:disabled {
      color: $color-gray-8;
      #{$this}__icon {
        fill: $color-gray-8;
      }
    }
  }
  // type secondary
  &--secondary {
    z-index: 1;
    font-weight: 600;
    color: $color-white !important;
    text-transform: uppercase;
    background-image: $green-gradient;
    border: none;

    &::before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      content: '';
      background-image: $green-gradient-hover;
      border-radius: 2px;
      opacity: 0;
      transition: opacity $A;
    }

    &:hover::before {
      opacity: 1;
    }

    &:disabled {
      color: $color-gray-8 !important;
      background: $color-transparent;
      border: 1px solid $color-gray-5 !important;
    }

    &:disabled:hover::before {
      opacity: 0;
    }

    &--capitalize {
      font-weight: normal;
      text-transform: capitalize;
    }

    &--default-transform {
      font-weight: normal;
      text-transform: none;
    }

    .ripple-reaction {
      background-color: $color-ripple-1;
    }
  }
  // type purple
  &--purple {
    z-index: 1;
    font-weight: 600;
    color: $color-white !important;
    text-transform: uppercase;
    background-color: #302750;
    border: none;

    &:hover {
      background-color: #362a5f;
    }

    &:disabled {
      color: $color-gray-8 !important;
      background: $color-transparent;
      border: 1px solid $color-gray-5 !important;
    }

    &:disabled:hover {
      background: $color-transparent;
    }

    &--capitalize {
      font-weight: normal;
      text-transform: capitalize;
    }

    &--default-transform {
      font-weight: normal;
      text-transform: none;
    }

    .ripple-reaction {
      background-color: $color-ripple-1;
    }
  }
  // type white
  &--white {
    background-color: $color-white;
    border-color: $color-white;
    box-shadow: $box-shadow-card-1;

    &:disabled {
      color: $color-gray-8 !important;
    }

    &:hover {
      color: $black;
    }
  }
  // type red
  &--red {
    color: #e48282;
    background: #ffe4e4;
    border-color: #f6c4c4;

    &:hover {
      color: #e48282;
      border-color: #f6c4c4;
    }

    .ripple-reaction {
      background: #ffe4e4;
    }
  }
  // type border-grey
  &--border-grey-light {
    color: #acacac;
    background: $white;
    border-color: #eee;

    &:hover {
      color: #acacac;
      background: $white;
      border-color: #eee;
    }

    .ripple-reaction {
      background: #fafafa;
    }
  }
  // type border-grey
  &--border-grey {
    color: #919191;
    background: #fafafa;
    border-color: #eee;

    &:hover {
      color: #919191;
      background: $white;
      border-color: #eee;
    }

    .ripple-reaction {
      background: #fafafa;
    }
  }

  &--alfabank {
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    letter-spacing: normal;
    background: #ef3124;

    .app-button-control__content {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 0 27px;

      & > span {
        padding: 0 15px;
        margin: 0 auto;
      }
    }

    &:hover {
      color: #fff;
      background: #dd2a1e;
    }

    img {
      display: block;
      width: 17px;
    }

    &[disabled] {
      color: #fff;
      pointer-events: none;
      cursor: default;
      opacity: 0.5;
    }
  }
  // type green-border
  &--green-border {
    color: $color-brand-green;
    background-color: $color-transparent;
    border-color: $accent-light;

    &:hover {
      color: darken($color-brand-green, 10%);
      border-color: $color-brand-green;
    }

    &:disabled {
      color: $color-gray-8;
      border-color: $color-gray-5 !important;
    }

    &:disabled:hover {
      color: $color-gray-8;
      border-color: $color-gray-8;
    }

    &--uppercase {
      font-weight: 300;
    }
  }

  // type google
  &--google {
    padding: 0;
    font-size: rem(9);
    font-weight: 600;
    text-transform: uppercase;
    background: #efefef;
    border: none;

    &:hover {
      color: $color-black;
      background: darken(#efefef, 10%);
    }
    #{$this}__icon {
      @include size(20px);
    }

    .ripple-reaction {
      background-color: $color-ripple-1;
    }
  }
  // type sberbank
  &--sberbank {
    padding: 8px 24px;
    font-family: $SBSansInterface;
    font-size: rem(14);
    font-weight: 400;
    line-height: 16px;
    color: $white;
    text-transform: none;
    background: $malachite;
    border: 1px solid $malachite;

    &:hover {
      color: $white;
      background: darken($malachite, 5%);
      border-color: darken($malachite, 5%);
    }
    #{$this}__icon {
      @include size(22px);

      margin-right: 8px;
    }

    .ripple-reaction {
      background-color: $color-ripple-1;
    }
  }

  &--gosuslugi {
    padding: 8px 24px;
    font-family: $SBSansInterface;
    font-size: rem(14);
    font-weight: 400;
    line-height: 16px;
    color: #0d4cd3;
    text-transform: none;
    border: 1px solid #0d4cd3;

    &:hover {
      color: #0d4cd3;
    }
    #{$this}__icon {
      @include size(22px);

      margin-right: 8px;
    }

    .ripple-reaction {
      background-color: $color-ripple-1;
    }
  }

  &--sberbank-white {
    padding: 8px 24px;
    font-family: $SBSansInterface;
    font-size: rem(14);
    font-weight: 400;
    line-height: 16px;
    color: $graphite;
    text-transform: none;
    background: $white;
    border: 1px solid $asphalt;

    &:hover {
      color: darken($graphite, 5%);
      border-color: darken($asphalt, 5%);
    }
    #{$this}__icon {
      @include size(22px);

      margin-right: 8px;
    }

    .ripple-reaction {
      background-color: $color-ripple-1;
    }
  }

  &--green {
    font-weight: 600;
    color: #4c6154;
    text-transform: uppercase;
    background: #e4ffee;
    border: solid 1px #c4f6d6;

    &:hover {
      background: #e4ffee;
    }
  }

  // type fb
  &--fb {
    padding: 0;
    font-size: rem(9);
    font-weight: 600;
    color: $color-white;
    text-transform: uppercase;
    background: #39569a;
    border: none;

    &:hover {
      color: $color-white;
      background: darken(#39569a, 10%);
    }
    #{$this}__icon {
      @include size(20px);
    }

    .ripple-reaction {
      background-color: $color-ripple-1;
    }
  }

  // type vk
  &--vk {
    padding: 0;
    font-size: rem(9);
    font-weight: 600;
    color: $color-white;
    text-transform: uppercase;
    background: #5181b8;
    border: none;

    &:hover {
      color: $color-white;
      background: darken(#5181b8, 10%);
    }
    #{$this}__icon {
      @include size(20px);
    }

    .ripple-reaction {
      background-color: $color-ripple-1;
    }
  }

  // type apple
  &--apple {
    padding: 0;
    font-size: rem(11);
    font-weight: 600;
    color: $color-white;
    text-transform: none;
    background: $black;
    border: none;

    &:hover {
      color: $color-white;
      background: lighten($black, 10%);
    }
    #{$this}__icon {
      @include size(20px);
    }

    .ripple-reaction {
      background-color: $color-ripple-1;
    }
  }

  // type gray
  &--gray {
    @include link;

    flex-direction: column;
    height: auto;
    font-size: rem(13);
    font-weight: 300;
    color: #a2a2a2;
    text-transform: none;
    letter-spacing: normal;
    background: transparent;
  }

  // type link
  &--link {
    @include link;

    flex-direction: column;
    height: auto;
    font-size: rem(13);
    font-weight: 300;
    text-transform: none;
    letter-spacing: normal;
    background: transparent;

    #{$this}__icon {
      @include size(9px);

      margin-right: 9px;
      fill: currentColor;
    }

    &:disabled {
      color: $color-gray-8;
      pointer-events: none;
    }

    &:hover {
      background: transparent;
    }
  }

  // uppercase
  &--uppercase {
    font-weight: 600;
    text-transform: uppercase;
  }

  // capitalize
  &--capitalize {
    text-transform: capitalize;
  }
}
</style>
